// https://fluentsite.z22.web.core.windows.net/quick-start
import {
  FluentProvider,
  teamsLightTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  Spinner,
  tokens,
} from "@fluentui/react-components";

import React, { useState, useEffect } from "react";
import { HashRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import Privacy from "./Privacy";
import TermsOfUse from "./TermsOfUse";
import Tab from "./Tab";
import * as microsoftTeams from "@microsoft/teams-js";
import { TeamsFxContext } from "./Context";
import config from "./sample/lib/config";
import SupportTray from "./SupportTray";
//import { msalConfig, loginRequest } from "./authConfig";
import  "./sample/support_tray_tab/Announcement";
import { initializeMsal } from "../AuthProvider";
import { SupportTrayTab } from "./sample/SupportTrayTab";
//import { decode } from "punycode";
import { TeamsFx } from "@microsoft/teamsfx";
//const msalInstance = new PublicClientApplication(msalConfig);

/**
 * The main app which handles the initialization and routing of the app.
 */
export default function App_POC({ onThemeChange = () => {} }) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [userPrincipalName, setUserPrincipalName] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const reactClientId= process.env.REACT_APP_CLIENT_ID;
  const reactFunctionEndpoint = process.env.REACT_APP_FUNCTION_ENDPOINT;
  const resource_apiendpoint = reactFunctionEndpoint.split("://")[1];
  const scopes = `api://${resource_apiendpoint}/${reactClientId}/.default`;
  const [teamsToken, setTeamsToken] = useState("");
  const [apiToken, setApiToken] = useState("");

  useEffect(()=>{
    initializeMsal();
  },[]);

  const { loading, teamsUserCredential } = useTeamsUserCredential({
    initiateLoginEndpoint: config.initiateLoginEndpoint,
    clientId: config.clientId,
  });

  const [themeString, setThemeString] = useState("default");
  const [theme, setTheme] = useState(teamsLightTheme);

  useEffect(() => {
   
        microsoftTeams.initialize(()=>{
        console.log("Teams SDK initialized");

        microsoftTeams.getContext(async(context) => {
          //console.log("Teams context in app jsx:", context);
          const currentTheme = context.theme || "default";
          setThemeString(currentTheme);
          onThemeChange(currentTheme); // Notify the parent component of the initial theme
          const uName = context.userPrincipalName || "";
          setUserPrincipalName(uName);       
        });
        microsoftTeams.registerOnThemeChangeHandler((newTheme) => {
          console.log("app jsx - Theme changed to:", newTheme);
          setThemeString(newTheme);
          onThemeChange(newTheme);
        });     
    });

  },[onThemeChange]);

  useEffect(() => {
    if(userPrincipalName && accessToken) {
      //console.log("useeffect principal name :", userPrincipalName);
      //console.log("useeffect access token :", accessToken);
    }
  },[userPrincipalName, accessToken]);

  useEffect(()=> {

    const fetchToken = async() =>{
      try{
        await microsoftTeams.app.initialize();
        const ssoToken = await microsoftTeams.authentication.getAuthToken();
        //setAccessToken(ssoToken);
        console.log("Teams microsoftteams.app SSO Token: ", ssoToken);
        
        /* const ssoPayload = JSON.parse(atob(ssoToken.split(".")[1]));
        console.log("SSO token payload: ", ssoPayload);
        const teamsfx = new TeamsFx();
        const tokenResponse = await teamsfx.getCredential().getToken([scopes,],{forceRefresh: true});
        console.log("teamsfx token : ", tokenResponse.token);
        setAccessToken(tokenResponse.token);  */
        
      } catch (err){
        console.err("Token check error: ", err);
      }
    };

    fetchToken();


  },[]);
  
  useEffect(() => {
    console.log("app jsx - Applying theme:", themeString);
    switch (themeString) {
      case "dark":
        setTheme(teamsDarkTheme);
        break;
      case "contrast":
        setTheme(teamsHighContrastTheme);
        break;
      default:
        setTheme({
          ...teamsLightTheme,
          colorNeutralBackground3: "#eeeeee",
        });
        break;
    }
    console.log("Value in themeString in app jsx:", themeString);
  }, [themeString]);

  return (
    //*<MsalProvider instance = {msalInstance}>
    <TeamsFxContext.Provider value={{ theme, themeString, teamsUserCredential,userPrincipalName, accessToken,setUserPrincipalName,setAccessToken, }}>
      <FluentProvider theme={theme} style={{ background: tokens.colorNeutralBackground3 }}>
        <Router>
          {loading ? (
            <Spinner style={{ margin: 100 }} />
          ) : (
            <Routes>
              <Route path ="/"element={<SupportTrayTab/>}/>
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/termsofuse" element={<TermsOfUse />} />
              <Route path="/tab" element={<SupportTray />} />
              <Route path="/areatab" element={<Tab />} />
              <Route path="*" element={<Navigate to="/tab" />} />
            </Routes>
          )}
        </Router>
      </FluentProvider>
    </TeamsFxContext.Provider>
    /*</MsalProvider> */
  );
}
